import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Modal, Button, FormGroup, FormControl, ControlLabel, InputGroup } from 'react-bootstrap';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Loader from '../Loader/Loader';
import CurrencyConverter from '../CurrencyConverter/CurrencyConverter';
import { convert, showCurrencySymbol } from '../../helpers/currencyConvertion';
import validate from './validate';
import updateClaimRefundMutation from './updateClaimRefund.graphql';
import showToaster from '../../helpers/toasterMessages/showToaster';
import { withMutation } from '../../hoc/withGraphql';

import cs from '../../components/commonStyle.css';
import s from './AdminClaimModal.css';
import messages from '../../locale/jsonMessages';
class AdminClaimModal extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    state = { loader: false };
    async handleSubmit(values) {
        this.setState({ loader: true });
        const { currencyRates, currency, updateClaimRefund, reservationId, closeModal, refetch } = this.props;
        let claimRefund = convert(currencyRates.base, currencyRates.rates, values.claimRefund, currencyRates.to || currencyRates.base, currency);
        const { data } = await updateClaimRefund({ variables: { reservationId, claimRefund: parseFloat(claimRefund.toFixed(2)) } });
        if (data && data.updateClaimRefund && data.updateClaimRefund.status == 200) {
            refetch();
            closeModal();
            showToaster({ messageId: 'claimAmount', toasterType: 'success' })
        }
        else {
            closeModal();
            showToaster({ messageId: 'adminClaimModalError', toasterType: 'error' })
            this.setState({ loader: false });
        }
    }
    renderFormControl = ({ input, placeholder, type, meta: { touched, error }, className, disabled, isReadOnly }) => {
        const { formatMessage } = this.props.intl;
        const { currencyRates, toCurrency } = this.props;

        if (isReadOnly) {
            return (
                <div className={cx(s.hostClaimFieldStyle, 'commonInputField')}>
                    <CurrencyConverter amount={Number(input.value)} from={currencyRates.to} />
                </div>
            )
        }
        return (
            <div>
                <InputGroup>
                    <InputGroup.Addon>
                        {showCurrencySymbol(toCurrency) == '' ? toCurrency : showCurrencySymbol(toCurrency)}
                    </InputGroup.Addon>
                    <FormControl
                        {...input}
                        placeholder={placeholder}
                        type={type}
                        className={cx(className, 'commonInputField')}
                        disabled={disabled}
                    />
                </InputGroup>
                {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
            </div>
        )
    }
    render() {
        const { show, closeModal, claimedByHost, handleSubmit, reservationId, openHostModal } = this.props;
        const { formatMessage } = this.props.intl;
        const { loader } = this.state;
        return (
            <Modal show={show} onHide={closeModal} dialogClassName={cx(s.claimDetailsModalContainer, 'commonModalContainer')}>
                <Modal.Header closeButton className='commonModalHeader'>
                    <Modal.Title className='commonModalTitle'>{formatMessage(messages.adminClaimModalHeading)}</Modal.Title>
                </Modal.Header>
                <Modal.Body bsClass='commonModalBody'>
                    <form onSubmit={handleSubmit(this.handleSubmit)}>
                        <div className="oneColumnGrid">
                            <FormGroup className={cs.noMargin}>
                                <ControlLabel className='commonLabelText'>
                                    <FormattedMessage  {...messages.depositAmount} />
                                </ControlLabel>
                                <Field
                                    name="securityDeposit"
                                    type="text"
                                    component={this.renderFormControl}
                                    placeholder={formatMessage(messages.depositAmount)}
                                    isReadOnly
                                    disabled
                                />
                            </FormGroup>
                            {claimedByHost &&
                                <FormGroup className={cs.noMargin}>
                                    <ControlLabel className='commonLabelText'>
                                        <FormattedMessage  {...messages.claimAmountRequestedFromTheOwner} />
                                    </ControlLabel>
                                    <Field
                                        name="claimAmount"
                                        type="text"
                                        component={this.renderFormControl}
                                        placeholder={formatMessage(messages.claimAmount)}
                                        isReadOnly
                                    />
                                </FormGroup>
                            }
                            <FormGroup className={cs.noMargin}>
                                <ControlLabel className='commonLabelText'>
                                    <FormattedMessage  {...messages.claimRefund} /><sup className='isRequiredStar'>*</sup>
                                </ControlLabel>
                                <Field
                                    name="claimRefund"
                                    type="text"
                                    component={this.renderFormControl}
                                    placeholder={formatMessage(messages.enterClaimRefund)}
                                />
                            </FormGroup>
                        </div>
                        {claimedByHost &&
                            <div className={s.checkText}>{formatMessage(messages.pleaseCheck)} {' '} <a href={"javascript:void(0)"} onClick={() => { closeModal(); openHostModal(true, reservationId) }}>{formatMessage(messages.claimDetails)}</a></div>}

                        <div className={cx(cs.spaceTop4, 'doubleBtnFlexEnd')}>
                            <Button onClick={closeModal} className={cs.btnPrimaryBorder}> {formatMessage(messages.cancel)} </Button>
                            <Loader type={"button"} buttonType={"submit"} label={formatMessage(messages.submitRefund)} show={loader} disabled={loader} className={cx(cs.btnPrimary, 'loaderButtonFlex')} />
                        </div>
                    </form>
                </Modal.Body>
            </Modal >)
    }
}
AdminClaimModal = reduxForm({ form: 'AdminClaimModalForm', validate })(AdminClaimModal);
const mapState = state => ({
    currencyRates: state.currency,
    toCurrency: state.currency.base,
});
const mapProps = {};
export default injectIntl(withMutation(updateClaimRefundMutation, { name: 'updateClaimRefund' })(withStyles(cs, s)(connect(mapState, mapProps)(AdminClaimModal))));